import { render } from "./MinifyTool.vue?vue&type=template&id=22a8b9d0"
import script from "./MinifyTool.vue?vue&type=script&lang=js"
export * from "./MinifyTool.vue?vue&type=script&lang=js"

import "./MinifyTool.vue?vue&type=style&index=0&id=22a8b9d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__